import React from "react";
import { LuBookOpen, LuDownload, LuPencil } from "react-icons/lu";
import { Button } from "../../components/ui";
import { plural, t } from "../../i18n";
import { ptBR } from "../../i18n/pt-BR";

interface ReferencesPanelProps {
  count: number;
  loading: boolean;
  onView: () => void;
  onRedownload: () => void;
}

/** "N referências incluídas" no último resumo baixado, com "Ver ou alterar" e "Baixar novamente". */
export const ReferencesPanel: React.FC<ReferencesPanelProps> = ({ count, loading, onView, onRedownload }) => (
  <div className="flex flex-wrap items-center gap-3 rounded-card border border-line bg-surface px-4 py-3.5 shadow-card">
    <span className="grid h-10 w-10 shrink-0 place-items-center rounded-control bg-success-soft text-success" aria-hidden>
      <LuBookOpen size={20} />
    </span>
    <span className="flex min-w-[180px] flex-1 flex-col">
      <strong className="text-body font-semibold">
        {plural(count, ptBR.references.panel.count)}
      </strong>
      <span className="text-caption text-fg-subtle">{t("references.panel.hint")}</span>
    </span>
    <span className="flex flex-wrap gap-2">
      <Button variant="outline" size="sm" icon={<LuPencil size={16} aria-hidden />} onClick={onView}>
        {t("references.panel.view")}
      </Button>
      <Button variant="outline" size="sm" icon={<LuDownload size={16} aria-hidden />} loading={loading} onClick={onRedownload}>
        {t("references.panel.redownload")}
      </Button>
    </span>
  </div>
);
